module.exports = __webpack_public_path__ + "img/icon-r-note.46e5dc94.svg";